@if (sidebarService.mobileOpen()) {
<div class="sidebar-overlay" (click)="sidebarService.close()"></div>
}
<aside class="sidebar" [class.collapsed]="collapsed()" [class.mobile-open]="sidebarService.mobileOpen()">
  <div class="sidebar-logo">
    <img [src]="themeService.isDarkMode() ? 'images/logo-dark-mode-text.png' : 'images/logo-light-mode-text.png'" alt="Autotaxatie Partners">
  </div>
  <nav class="sidebar-nav">
    @for (item of navItems; track item.id) {
    @if (item.children) {
    <div class="nav-group" [class.expanded]="isExpanded(item)">
      <button class="nav-item" [class.active]="isParentActive(item)" (click)="toggleExpand(item)">
        <app-icon [name]="item.icon" size="md" />
        <span>{{ item.label }}</span>
        <app-icon class="chevron" name="chevron-left" size="xs" />
      </button>
      <div class="nav-children">
        @for (child of item.children; track child.id) {
        <a class="nav-child" [routerLink]="child.route" routerLinkActive="active"
          [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'exact', fragment: 'ignored' }">
          <span>{{ child.label }}</span>
        </a>
        }
      </div>
    </div>
    } @else {
    <a class="nav-item nav-item--{{item.id}}" [routerLink]="item.route" routerLinkActive="active">
      <app-icon [name]="item.icon" size="md" />
      <span>{{ item.label }}</span>
      @if (item.id === 'aanbevolen' && recommendationService.count() > 0) {
      <span class="nav-badge">{{ recommendationService.count() }}</span>
      }
    </a>
    }
    }
  </nav>
  <button class="sidebar-toggle" (click)="toggleSidebar()">
    <app-icon name="chevron-left" size="sm" />
  </button>
  <div class="sidebar-contact">
    <span class="sidebar-contact-title">Contact</span>
    <a class="sidebar-contact-link" href="tel:+31888833222">
      <app-icon name="phone" size="sm" />
      <span>088 - 883 32 22</span>
    </a>
    <a class="sidebar-contact-link" href="mailto:info@autotaxatiepartners.nl">
      <app-icon name="mail" size="sm" />
      <span>info@autotaxatiepartners.nl</span>
    </a>
  </div>
</aside>